module.exports = __webpack_public_path__ + "media/images/sandbox/flyer_opt-42e8249c94dbfb358606ef599bae29af.png";